import { Button, Tab, Tabs } from '@material-ui/core';
import MuiPhoneNumber from 'material-ui-phone-number';
import React, { useEffect, useReducer, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { USER_INVITE } from '../../../../constants/RoleConsts';
import { UserDepartment } from '../../../../constants/UserRoles';
import CustomMultiSelect from '../../../../shared/form-controls/custom-multi-select/Custom-Multi-Select';
import CustomSelect from '../../../../shared/form-controls/custom-select/Custom-Select';
import CustomTextField from '../../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import LinearProgressBar from '../../../../shared/progress-bar/Progress';
import { formDataValidate, handleValidation } from '../../../../utils/formUtils';
import { notificationManager } from '../../../../utils/NotificationUtils';
import {
  editUserDetails,
  getRolePermissions,
  inviteNewUser,
} from '../../../../utils/PropertyAPIUtils';
import {
  allBrandsSelector,
  allGroupsSelector,
  allHotelsSelector,
  userInviteSelectedRestaurantSelector,
  fetchAllRestaurant,
  fetchAllRestaurantByHotelId,
  selectedHotelSelector,
} from '../../../property/propertySlice';
import './User-Invite.scss';
import { checkAuthState } from '../../../../utils/APIUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../utils/loaderSlice';

const UserInvite = (props) => {
  const { onToggle, user, lstRoles, showLoader = () => {}, onSaved } = props;
  const dispatch = useDispatch();
  const [tabValue, setTabValue] = useState(0);
  const [isTabInValid, setIsTabInValid] = useState(true);
  const lstGroup = useSelector(allGroupsSelector);
  const lstBrand = useSelector(allBrandsSelector);
  const lstHotel = useSelector(allHotelsSelector);
  const originalRestList = useSelector(userInviteSelectedRestaurantSelector);
  const [lstPermissions, setLstPermissions] = useState([]);
  const [filteredBrands, setFilteredBrands] = useState([]);
  const [filteredHotels, setFilteredHotels] = useState([]);
  const [selectedRoleDetails, setSelectedRoleDetails] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const [isPhoneNumberEmpty, setIsPhoneNumberEmpty] = useState(false);
  const [isCoManager, setIsCoManager] = useState(false);
  const [isFnBAgent, setIsFnBAgent] = useState(false);
  const [hotelSearchValue, setHotelSearchValue] = useState('');
  const [brandSearchValue, setBrandSearchValue] = useState('');
  const [cognitoUser, setCognitoUser] = useState(null);
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    groupId: {
      value: '',
      fieldName: 'Group',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    brandId: {
      value: [],
      fieldName: 'Brand(s)',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    hotelId: {
      value: [],
      fieldName: 'Hotel(s)',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    email: {
      value: '',
      fieldName: 'Email',
      errors: {},
      validations: ['required', 'validEmail'],
      tab: 0,
    },
    firstName: {
      value: '',
      fieldName: 'First Name',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    lastName: {
      value: '',
      fieldName: 'Last Name',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    departmentId: {
      value: '',
      fieldName: 'Department',
      errors: {},
      validations: [],
      tab: 0,
    },
    employeeId: {
      value: '',
      fieldName: 'Enter Employee ID',
      errors: {},
      validations: [],
      tab: 0,
    },
    phoneNumber: {
      value: '',
      fieldName: 'Phone Number',
      errors: {},
      validations: [],
      tab: 0,
    },
    roles: {
      value: [],
      fieldName: 'Role(s)',
      errors: {},
      validations: ['required'],
      tab: 1,
    },
    restaurantId: {
      value: '',
      fieldName: 'Restaurant',
      errors: {},
      validations: [],
      tab: 1,
    },
  });

  useEffect(() => {
    (async () => {
      const currUser = await checkAuthState();
      setCognitoUser(currUser?.attributes);
    })();
  }, []);

  useEffect(() => {
    setIsSuperAdmin(cognitoUser && cognitoUser['custom:role'] === 'SUPER_ADMIN');
  }, [cognitoUser]);

  useEffect(() => {
    (async () => {
      try {
        dispatch(stepUpLoaderCount());
        if (formData?.roles?.value && formData?.roles?.value?.length) {
          if (formData?.roles?.value?.length === 1) {
            setSelectedRoleDetails(
              lstRoles?.find((role) => formData?.roles?.value?.[0] === role?.id),
            );
          } else {
            const result = await getRolePermissions(formData?.roles?.value);
            setLstPermissions(result?.data?.getCustomRolePermissions?.permissions);
          }
        } else {
          setLstPermissions([]);
        }
      } catch (e) {
        notificationManager('danger', 'Failed to retrieve user roles');
      } finally {
        dispatch(stepDownLoaderCount());
      }
    })();
  }, [formData?.roles?.value]);

  useEffect(() => {
    if (user && lstRoles?.length) {
      const currFields = { ...formData };
      for (let field in user) {
        if (field !== 'role') {
          if (currFields.hasOwnProperty(field)) {
            if (field === 'brandId' || field === 'hotelId') {
              currFields[field].value = user?.[field] ? user?.[field]?.split(',') : [];
            } else {
              currFields[field].value = user?.[field];
            }
          }
        }
      }
      setFormData(currFields);
    }
  }, [user, lstRoles]);

  useEffect(() => {
    if (formData?.roles?.value) {
      let isIncludeCoManager = formData?.roles?.value?.includes('CULINARY_OPERATIONS_MANAGER');

      let isFnBAgent = formData?.roles?.value?.includes('FnB_AGENT');

      if (formData?.roles?.value?.length > 1 && (isIncludeCoManager || isFnBAgent)) {
        setIsTabInValid(true);
        formData.roles.validations = ['required'];
        formData.roles.errors = {
          required: isIncludeCoManager
            ? 'Culinary Operation Manager cannot be assign with another role'
            : isFnBAgent
            ? 'F&B Agent cannot be assign with another role'
            : '',
        };
      }
      if (!isIncludeCoManager && !isFnBAgent) {
        formData.restaurantId = {
          ...formData?.restaurantId,
          value: '',
        };
      }

      formData.restaurantId = {
        ...formData?.restaurantId,
        validations: isIncludeCoManager || isFnBAgent ? ['required'] : [],
      };

      setFormData(formData);
      setIsCoManager(isIncludeCoManager || false);
      setIsFnBAgent(isFnBAgent || false);
    }
  }, [formData?.roles?.value]);

  useEffect(() => {
    if (lstHotel && formData?.brandId?.value?.length) {
      setFilteredHotels(lstHotel.filter((hotel) => formData.brandId.value.includes(hotel.brandId)));
    } else if (lstHotel && formData?.groupId?.value) {
      setFilteredHotels(lstHotel.filter((hotel) => hotel.groupId === formData.groupId.value));
    } else {
      setFilteredHotels([]);
    }
    if (hotelSearchValue) {
      onSearchHotelList(hotelSearchValue);
    }
  }, [formData?.groupId?.value, formData?.brandId?.value, lstHotel, hotelSearchValue]);

  useEffect(() => {
    if (formData?.groupId?.value) {
      const brand = lstBrand?.filter((brand) => brand?.groupId === formData?.groupId?.value);
      const hotel = lstHotel?.filter((hotel) => hotel?.groupId === formData?.groupId?.value);

      if (brand?.length <= 0 && hotel?.length <= 0) {
        formData.groupId.errors = {
          required: 'The Group does not have any Brand and Hotel',
        };
        formData.groupId.validations = ['required'];
      } else if (hotel?.length <= 0) {
        formData.groupId.errors = {
          required: 'The Group does not have any Hotel',
        };
        formData.groupId.validations = ['required'];
      } else {
        formData.groupId.errors = { required: null };
        formData.groupId.validations = ['required'];
      }
    }
  }, [formData?.groupId?.value]);

  useEffect(() => {
    if (selectedRoleDetails && formData?.roles?.value?.length === 1) {
      setLstPermissions(selectedRoleDetails?.permissions);
    }
  }, [selectedRoleDetails, formData?.roles?.value]);

  useEffect(() => {
    const currTabFromData = Object.fromEntries(
      Object.entries(formData)?.filter(([key, field]) => field?.tab === tabValue),
    );

    const isValid = formDataValidate(currTabFromData, false);
    if (formData?.groupId?.errors?.required !== null && formData?.groupId?.value) {
      setIsTabInValid(true);
    } else if (formData?.roles?.errors?.required) {
      setIsTabInValid(true);
    } else {
      setIsTabInValid(!isValid);
    }
  }, [formData, tabValue]);

  const selectedHotelItem = useSelector(selectedHotelSelector);
  const wasFieldVisibleRef = useRef(false);
  const prevHotelIdsRef = useRef(null);
  const prevPrimaryHotelRef = useRef(null);

  useEffect(() => {
    const fieldVisible = (isCoManager || isFnBAgent) && tabValue === 1;
    const becameVisible = fieldVisible && !wasFieldVisibleRef.current;
    wasFieldVisibleRef.current = fieldVisible;

    if (!fieldVisible) {
      prevHotelIdsRef.current = null;
      prevPrimaryHotelRef.current = null;
      return;
    }

    const hotelIdsArray = formData?.hotelId?.value || [];
    const hotelIds = hotelIdsArray.join(',');
    const primaryHotelId = hotelIdsArray[0] || '';
    if (hotelIds && (becameVisible || hotelIds !== prevHotelIdsRef.current)) {
      dispatch(fetchAllRestaurantByHotelId(hotelIds));
      prevHotelIdsRef.current = hotelIds;
    }
    if (primaryHotelId && (becameVisible || primaryHotelId !== prevPrimaryHotelRef.current)) {
      dispatch(fetchAllRestaurant(primaryHotelId));
      prevPrimaryHotelRef.current = primaryHotelId;
    }
    if (!hotelIds && formData?.restaurantId?.value) {
      setFormData({ restaurantId: { ...formData.restaurantId, value: '' } });
    }
  }, [tabValue, isCoManager, isFnBAgent, formData?.hotelId?.value, dispatch]);

  const handleTabChange = (event, newValue) => {
    if (tabValue < newValue) {
      if (validate(tabValue)) setTabValue(newValue);
    } else setTabValue(newValue);
  };

  const validate = (tabValue) => {
    const updatedFields = {};
    // If tabValue is given, filter out the form fields in current tab
    const currTabFromData = Object.fromEntries(
      Object.entries(formData)?.filter(([key, field]) => field?.tab === tabValue),
    );

    const isValid = formDataValidate(currTabFromData, updatedFields);
    setFormData(updatedFields);
    return isValid;
  };

  const onNextClick = () => {
    if (validate(tabValue)) {
      setTabValue(tabValue + 1);
    }
  };

  const handlePhoneNoChange = (phone, country) => {
    if (phone?.slice(1) !== country?.dialCode) {
      const currField = { ...formData }.phoneNumber;
      currField.value = phone;
      handleValidation(currField);
      setFormData({ phoneNumber: currField });
      setIsPhoneNumberEmpty(false);
    } else {
      setIsPhoneNumberEmpty(true);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validate(0) && validate(1)) {
      setLoading(true);
      showLoader(true);

      const payload = {};

      for (let field in formData) {
        if (field === 'brandId' || field === 'hotelId') {
          payload[field] =
            formData?.[field]?.value && formData?.[field]?.value?.length > 0
              ? formData?.[field]?.value?.join(',')
              : '';
        } else if (field === 'email') {
          payload[field] = formData?.[field]?.value?.trim();
        } else {
          payload[field] = formData?.[field]?.value;
        }
      }

      payload['imageUrl'] = null;

      if (isPhoneNumberEmpty) {
        payload.phoneNumber = '';
      }

      const permissionList = lstPermissions?.reduce((list, curr) => {
        curr?.accessLevel?.forEach((al) => {
          list[al.permission] = al?.level;
        });
        return list;
      }, {});

      if (formData?.roles?.value?.length > 1) {
        payload['role'] = {
          id: '',
          isDefault: false,
          name: 'Custom Role',
          permissions: permissionList,
        };
      } else {
        payload['role'] = {
          id: selectedRoleDetails?.id,
          isDefault: true,
          name: selectedRoleDetails?.name,
          permissions: {},
        };
      }
      if (isCoManager || isFnBAgent) {
        payload['restaurantId'] = formData.restaurantId?.value;
      } else {
        payload['restaurantId'] = '';
      }

      try {
        if (user) {
          payload['id'] = user?.id;
          await editUserDetails(payload);
          notificationManager('success', 'User details edited successfully');
        } else {
          await inviteNewUser(payload);
          notificationManager('success', 'Invitation sent successfully');
        }
        setLoading(false);
        onToggle(USER_INVITE, false, null);
        onSaved && onSaved();
      } catch (error) {
        if (error?.graphQLErrors) {
          notificationManager('danger', error?.graphQLErrors?.[0]?.message);
        } else {
          user
            ? notificationManager('danger', 'User edit failed')
            : notificationManager('danger', 'Invitation sent failed');
        }
        setLoading(false);
      }
    }
  };

  const onCancel = (e) => {
    onToggle(USER_INVITE, false, null);
  };

  useEffect(() => {
    if (!hotelSearchValue && !brandSearchValue) {
      const filteredHotels = lstHotel?.filter((hotel) =>
        formData?.brandId?.value?.includes(hotel?.brandId),
      );
      const filteredBrands = lstBrand?.filter((brand) =>
        formData?.groupId?.value?.includes(brand?.groupId),
      );
      setFilteredHotels(filteredHotels || []);
      setFilteredBrands(filteredBrands || []);
    }
  }, [
    formData?.brandId?.value,
    formData?.groupId?.value,
    lstBrand,
    lstHotel,
    hotelSearchValue,
    brandSearchValue,
  ]);

  const onSearchHotelList = (searchItem) => {
    setHotelSearchValue(searchItem);
    let hotels = lstHotel || [];
    if (formData?.brandId?.value?.length) {
      hotels = hotels?.filter((hotel) => formData.brandId.value.includes(hotel.brandId));
    } else if (formData?.groupId?.value) {
      hotels = hotels?.filter((hotel) => hotel.groupId === formData.groupId.value);
    }
    const filtered = hotels?.filter((h) => h.name.toLowerCase().includes(searchItem.toLowerCase()));
    setFilteredHotels(filtered);
  };

  const onSearchBrandList = async (searchItem) => {
    setBrandSearchValue(searchItem);
    const filterList = lstBrand
      ?.filter((brand) => formData?.groupId?.value?.includes(brand?.groupId))
      ?.filter((item) => {
        return item?.name?.toLowerCase()?.includes(searchItem?.toLowerCase());
      });
    return setFilteredBrands(filterList);
  };

  const changeBrandAndHotel = (level) => {
    const { brandId, hotelId } = formData;

    let newBrandVal = { ...brandId };
    let newHotelVal = { ...hotelId };

    if (level === 'group') {
      newBrandVal.value = [];
      newHotelVal.value = [];
    } else if (level === 'brand') {
      if (newBrandVal.value.length === 0) {
        newHotelVal.value = [];
      } else {
        const validHotels = lstHotel.filter((hotel) =>
          hotel.brandIds.some((brandId) => newBrandVal.value.includes(brandId)),
        );
        const remainingHotels = newHotelVal.value.filter((hotelId) =>
          validHotels.some((hotel) => hotel.id === hotelId),
        );
        newHotelVal.value = remainingHotels.length
          ? remainingHotels
          : validHotels.map((hotel) => hotel.id);
      }
    }

    setFormData({ brandId: newBrandVal, hotelId: newHotelVal });
  };

  const renderCustomDisplay = (selectedValue, list, formField) => {
    const displayName = selectedValue
      .map((itemData) => {
        const item = list.find((ild) => ild.id === itemData);
        return item ? item?.name : null;
      })
      .filter((name) => name);
    const formItem = { ...formData[formField] };
    formItem.fieldName = `${selectedValue.length} selected`;
    return <span>{displayName.length > 0 ? displayName.join(', ') : ''}</span>;
  };

  const filterHotelsByBrands = (selectedBrandIds) => {
    const hotelIds = new Set(
      lstHotel
        ?.filter((hotels) => selectedBrandIds?.includes(hotels?.brandId))
        ?.map((hotel) => hotel?.id),
    );

    const current = formData?.hotelId?.value || [];
    const selectedHotel = current?.filter((id) => hotelIds?.has(id));
    setFormData({
      hotelId: { ...formData?.hotelId, value: selectedHotel },
      restaurantId: { ...formData?.restaurantId, value: '' },
    });
  };

  const isFilteredBrandsMultiple = filteredBrands?.length > 1;

  const isFilteredHotelsMultiple = filteredHotels?.length > 1;

  return (
    <div className='container mt-4 mb-4 user-invite-container'>
      <div className='d-flex justify-content-center page-title'>
        {user ? 'Edit' : 'Invite'} User
      </div>
      <div className='d-flex justify-content-center mt-3'>
        <Tabs
          value={tabValue}
          variant='fullWidth'
          indicatorColor='primary'
          onChange={handleTabChange}
          aria-label='brands-add-tabs'
          textColor='primary'
          className='property-tabs'
        >
          <Tab label='Details' />
          <Tab label='Roles' />
        </Tabs>
      </div>
      <div className='card shadow detail-view-65 mt-4'>
        {tabValue === 0 && (
          <>
            <div className='d-flex justify-content-center my-3 tab-title'>Details</div>
            <div className='col-12 px-2'>
              <div className='row mx-4'>
                <div className='col-md-4'>
                  {!isSuperAdmin ? (
                    <CustomSelect
                      item={formData?.groupId}
                      handleInputChange={(e) => {
                        setFormData({ groupId: e });
                        changeBrandAndHotel('group');
                      }}
                      labelPrefix='Select'
                      options={lstGroup}
                      shouldAppendCode={true}
                      hideNullOption={true}
                      addCodeToEnd={true}
                    />
                  ) : (
                    <CustomSelect
                      item={formData?.groupId}
                      handleInputChange={(e) => {
                        setFormData({ groupId: e });
                        changeBrandAndHotel('group');
                      }}
                      labelPrefix='Select'
                      options={lstGroup}
                      shouldAppendCode={true}
                      hideNullOption={true}
                      addCodeToEnd={true}
                      isSearchable={true}
                      searchPlaceholder={'Search Group'}
                    />
                  )}
                </div>

                <div className='col-md-4 mb-3'>
                  <CustomMultiSelect
                    item={formData?.brandId}
                    options={filteredBrands}
                    labelPrefix='Select'
                    hideNullOption={true}
                    handleInputChange={(e) => {
                      setFormData({ brandId: e });
                      filterHotelsByBrands(e?.value);
                    }}
                    valueField='id'
                    selectAllOption={isFilteredBrandsMultiple}
                    searchValue={brandSearchValue}
                    searchPlaceholder='Search Brand'
                    isSearchable={true}
                    getSearchInput={onSearchBrandList}
                    labelField='name'
                    isCustomDisplay={true}
                    renderCustomDisplay={(e) => renderCustomDisplay(e, filteredBrands, 'brandId')}
                  />
                </div>
                <div className='col-md-4 mb-3'>
                  <CustomMultiSelect
                    item={formData?.hotelId}
                    getSearchInput={onSearchHotelList}
                    searchValue={hotelSearchValue}
                    searchPlaceholder='Search Hotel'
                    options={filteredHotels}
                    hideNullOption={true}
                    labelPrefix='Select'
                    handleInputChange={(e) => {
                      setFormData({
                        hotelId: e,
                        restaurantId: { ...formData?.restaurantId, value: '' },
                      });
                    }}
                    valueField='id'
                    labelField='name'
                    selectAllOption={isFilteredHotelsMultiple}
                    isSearchable={true}
                    isCustomDisplay={true}
                    renderCustomDisplay={(e) => renderCustomDisplay(e, filteredHotels, 'hotelId')}
                  />
                </div>
              </div>
              <div className='row mx-4'>
                <div className='col-md-4 mb-3'>
                  <CustomTextField
                    item={formData.email}
                    handleInputChange={(e) => {
                      setFormData({ email: e });
                    }}
                    disabled={user != null}
                  />
                </div>
                <div className='col-md-4 mb-3'>
                  <CustomTextField
                    item={formData.firstName}
                    handleInputChange={(e) => {
                      setFormData({ firstName: e });
                    }}
                    maxLength={100}
                    endAdornment={true}
                    characterCount={true}
                    multiline={true}
                  />
                </div>
                <div className='col-md-4 mb-3'>
                  <CustomTextField
                    item={formData?.lastName}
                    handleInputChange={(e) => {
                      setFormData({ lastName: e });
                    }}
                    maxLength={100}
                    endAdornment={true}
                    characterCount={true}
                    multiline={true}
                  />
                </div>
              </div>
              <div className='row mx-4'>
                <div className='col-md-4 mb-3'>
                  <CustomSelect
                    item={formData?.departmentId}
                    handleInputChange={(e) => {
                      setFormData({ departmentId: e });
                    }}
                    labelPrefix='Select'
                    options={UserDepartment}
                  />
                </div>
                <div className='col-md-4 mb-3'>
                  <CustomTextField
                    item={formData?.employeeId}
                    handleInputChange={(e) => {
                      setFormData({ employeeId: e });
                    }}
                  />
                </div>
                <div className='col-md-4 mb-3'>
                  <MuiPhoneNumber
                    name='phone'
                    label='Phone Number'
                    data-cy='user-phone'
                    defaultCountry={'in'}
                    disableAreaCodes
                    autoFormat={true}
                    countryCodeEditable={false}
                    value={formData?.phoneNumber?.value}
                    className='col-md-12'
                    error={formData?.phoneNumber?.errors?.required ? true : false}
                    helperText={formData?.phoneNumber?.errors?.required}
                    onChange={(phone, country) => handlePhoneNoChange(phone, country)}
                    sx={{ '& svg': { height: '1.2rem' } }}
                  />
                </div>
              </div>
            </div>
          </>
        )}
        {tabValue === 1 && (
          <>
            <div className='d-flex justify-content-center mt-3 mb-2 tab-title'>Roles</div>
            <div className='d-flex justify-content-center mb-3 '>
              Select relevant Role(s) from the dropdown below.
            </div>
            <div className='d-flex justify-content-center my-3 '>
              <div className={!isCoManager && !isFnBAgent ? 'col-md-4 mb-3' : 'col-md-4 mb-3 me-4'}>
                <CustomMultiSelect
                  item={formData?.roles}
                  labelPrefix='Select'
                  options={lstRoles}
                  hideNullOption={true}
                  handleInputChange={(e) => {
                    setFormData({ roles: e });
                  }}
                  valueField='id'
                  labelField='name'
                  isCustomDisplay={true}
                  renderCustomDisplay={(e) => renderCustomDisplay(e, lstRoles, 'roles')}
                />
              </div>
              {(isCoManager || isFnBAgent) && (
                <div className='col-md-4 mb-3'>
                  <CustomSelect
                    item={formData?.restaurantId}
                    handleInputChange={(e) => {
                      setFormData({ restaurantId: e });
                    }}
                    labelPrefix='Select'
                    options={originalRestList?.filter(
                      (i) => !i?.sk?.includes('RESTAURANT#CHEF#') && !!i?.isActive,
                    )}
                    hideNullOption
                  />
                </div>
              )}
            </div>
            <div className='row mx-5 permissions'>
              {lstPermissions.length > 0 &&
                lstPermissions?.map((perm, key) => (
                  <div className='col-md-3 mb-4' key={key}>
                    <div className='permission-title-header ms-4'>{perm.category}</div>
                    <div className='d-flex flex-column mt-3'>
                      {perm.accessLevel?.map((accessLevel, index) => (
                        <div className='d-flex align-items-center mb-3' key={index}>
                          <div
                            className={`permission-indicator ${
                              accessLevel?.level === 2
                                ? 'permission-indicator-full-access'
                                : accessLevel?.level === 1
                                ? 'permission-indicator-view-only'
                                : 'permission-indicator-no-access'
                            }`}
                          >
                            {}
                          </div>
                          <div>{accessLevel?.name}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
            </div>
          </>
        )}
        <div className='row mx-2 mt-auto px-4 w-100 pb-5'>
          <div className='col-md-12 d-flex justify-content-end'>
            {tabValue < 1 ? (
              <Button
                variant='contained'
                color='primary'
                onClick={onNextClick}
                size='large'
                disabled={isTabInValid}
                className='me-3'
              >
                Next
              </Button>
            ) : (
              <Button
                variant='contained'
                color='primary'
                onClick={handleSubmit}
                className='me-3'
                disabled={isTabInValid}
                size='large'
              >
                {user ? 'Edit User' : 'Send Invite'}
              </Button>
            )}
            <Button
              disabled={loading}
              variant='outlined'
              size='large'
              color='secondary'
              onClick={(e) => onCancel(e)}
            >
              Cancel
            </Button>
          </div>
          {loading && (
            <div className='pt-4 col-md-12'>
              <LinearProgressBar />
            </div>
          )}
        </div>
      </div>
      {tabValue === 1 && (
        <div className='mt-2 d-flex permissions ms-5 pb-5'>
          <div className='d-flex align-items-center me-5'>
            <div className='permission-indicator permission-indicator-full-access me-2'></div>
            <span className='permission-indicator-label'>Add / Edit / Delete</span>
          </div>
          <div className='d-flex align-items-center me-5'>
            <div className='permission-indicator permission-indicator-view-only me-2'></div>
            <span className='permission-indicator-label'>View Only</span>
          </div>
          <div className='d-flex align-items-center me-5'>
            <div className='permission-indicator permission-indicator-no-access me-2'></div>
            <span className='permission-indicator-label'>No Access</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserInvite;
